import styled from "styled-components";
import Upload from "./uploadTutorial.jsx"
import DeleteVideo from "./deleteVideo.jsx"
import RutaTutorial from "./rutaTutorial.jsx"
import CreateRuta from "./createRuta.jsx"
import DeleteRuta from "./deleteRuta.jsx"
import SubirImagen from'./subirImagen.jsx'
import SubirVideo from "./subirVideo.jsx"
import {useState,Fragment} from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import AddRoadIcon from '@mui/icons-material/AddRoad';
import MmsIcon from '@mui/icons-material/Mms';

const Container=styled.div`
	height:85vh;
	overflow:auto;
	display: flex;
	font-family: "Poppins", sans-serif;
`;

const ContainerToggleButtons=styled.div`
	padding:10px;
	position:sticky;
	top:1px
`;

const ContainerModules=styled.div`
	width:90%;
	min-width:500px;
`;


export default  function AdminTutorials(){
	const [alignment, setAlignment] = useState('Tutorials');

	let handleChange=(e)=>{
		setAlignment(e.target.value)
	}
	let sxToggles={ writingMode: 'vertical-rl', textOrientation: 'upright',fontSize:"11px"};


	let seleccion=()=>{
		let rsp="";
		switch(alignment){
			case 'Tutorials':
				rsp = 	<Fragment>
							<Upload/>
							<DeleteVideo/>
						</Fragment>
				break;
			case 'rutas':
				rsp =
				<Fragment>
					<CreateRuta/>					
					<RutaTutorial/>
					<DeleteRuta/>
				</Fragment>
				break;
			case 'video/imagen':
				rsp =
				<Fragment>	
					<SubirImagen/>
					<SubirVideo/>					
				</Fragment>
				break;
			default:
		}
		return rsp		
	}

	return(
	<Container>
		<ContainerToggleButtons >
			<ToggleButtonGroup color="primary" value={alignment} exclusive onChange={handleChange} aria-label="Platform"orientation="vertical" >
      			<ToggleButton value="Tutorials"  sx={sxToggles}><OndemandVideoIcon/>Tutoriales</ToggleButton>
      			<ToggleButton value="rutas"  sx={sxToggles}><AddRoadIcon/>rutas</ToggleButton>
      			<ToggleButton value="video/imagen"  sx={sxToggles}><MmsIcon/>video/imagen</ToggleButton>
    		</ToggleButtonGroup>
		</ContainerToggleButtons>
		<ContainerModules>
			{seleccion()}	
			
		</ContainerModules>
		

	</Container>
	)
}